import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// 통계 (상점, 허브)
class StatsApi extends Requestor {
    /**
     * 상점 데일리 통계 조회
     */
    getStoreStatsDaily(params) {
        return this.get({
            url: '/api/store-stats/daily',
            params,
        });
    }
    /**
     * 상점 월별 통계 조별
     */
    getStoreStatsMonthly(params) {
        return this.get({
            url: '/api/store-stats/monthly',
            params,
        });
    }
    /**
     * 상점 시간대별 통계 조회
     */
    getStoreStatsHourly(params) {
        return this.get({
            url: '/api/store-stats/hourly',
            params,
        });
    }
    /**
     * 상점 요일별 통계 조회
     */
    getStoreStatsDayOfWeek(params) {
        return this.get({
            url: '/api/store-stats/day-of-week',
            params,
        });
    }
    /**
     * 상점 공유상점 통계 조회
     */
    getStoreStatsShared(params) {
        return this.get({
            url: '/api/store-stats/share-store',
            params,
        });
    }
    /**
     * 허브 데일리 통계 조회
     */
    getHubStatsDaily(params) {
        return this.get({
            url: '/api/v2/hubs/stats/daily',
            params,
        });
    }
    /**
     * 허브 월별 통계 조회
     */
    getHubStatsMonthly(params) {
        return this.get({
            url: '/api/v2/hubs/stats/monthly',
            params,
        });
    }
    /**
     * 허브 시간대별 통계 조회
     */
    getHubStatsHourly(params) {
        return this.get({
            url: '/api/v2/hubs/stats/hourly',
            params,
        });
    }
    /**
     * 허브 요일별 통계 조회
     */
    getHubStatsDayOfWeek(params) {
        return this.get({
            url: '/api/v2/hubs/stats/day-of-week',
            params,
        });
    }
}
export const statsApi = new StatsApi(clientInstance);
